import React from 'react';
import { createPortal } from 'react-dom';
import { Sparkles, X } from 'lucide-react';

/**
 * iter137 — NewFeatureAnnouncementModal
 *
 * Blocking modal shown on the first login after the "Analizza Schedina"
 * push notification when the user hasn't opened it. "Più tardi" leaves
 * the tutorial pending so it appears again on the next login; "Prova
 * subito" navigates to the analyzer and starts the coach-mark tour.
 */
export default function NewFeatureAnnouncementModal({ onTryNow, onLater, title, description, testId = 'new-feature-modal' }) {
  return createPortal(
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center p-5 bg-black/80 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      data-testid={testId}
    >
      <div className="rv-dark relative w-full max-w-sm rounded-3xl border border-cyan-400/30 bg-gradient-to-br from-[#111827] via-[#1a1a2e] to-[#0f1729] p-6 shadow-2xl">
        <button
          onClick={onLater}
          className="absolute top-3 right-3 text-gray-500 hover:text-white"
          aria-label="Chiudi"
          data-testid="new-feature-close-btn"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="mb-3 inline-flex items-center gap-2 px-2.5 py-1 rounded-full bg-cyan-500/10 border border-cyan-400/30">
          <Sparkles className="w-3.5 h-3.5 text-cyan-400" />
          <span className="text-[10px] font-black uppercase tracking-wider text-cyan-300">Nuova funzione</span>
        </div>

        <h2 className="text-2xl font-black text-white leading-tight mb-2">
          {title || <>Analizza la tua<br />multipla con l'IA</>}
        </h2>
        <p className="text-[13px] text-gray-400 leading-relaxed mb-5">
          {description || "Carica lo screenshot della tua selezione di partite: la nostra IA le riconosce, le confronta con i dati storici e ti suggerisce le modifiche più utili per alzare l'affidabilità."}
        </p>

        <div className="flex flex-col gap-2">
          <button
            onClick={onTryNow}
            className="w-full py-3 rounded-2xl bg-gradient-to-r from-cyan-500 to-purple-500 hover:from-cyan-400 hover:to-purple-400 text-xs font-black uppercase tracking-wider text-white shadow-lg transition-all"
            data-testid="new-feature-try-btn"
          >
            Prova subito
          </button>
          <button
            onClick={onLater}
            className="w-full py-3 rounded-2xl text-xs font-bold uppercase tracking-wider text-gray-400 hover:text-white transition-colors"
            data-testid="new-feature-later-btn"
          >
            Più tardi
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
